import React from 'react';
import { Input, Button, TitleModalRight, CheckboxTable, PaperClip } from 'components';
import { OperatorService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import moment from 'moment';
import { GoogleMapsIcon, PinIcon } from 'assets/icons';
import { connect } from 'react-redux';

interface Props {
	onClose?: any;
	item?: any;
	surcharge_title?: string;
}

// @ts-ignore
const google = window.google;

class EditQuote extends React.Component<Props> {

	state = {
		item: this.props.item
	}

	componentDidMount() {
		if (google && this.state.item?.latitude && this.state.item?.longitude) {
			this.setMap();
		}
	}

	setMap = async () => {
		const map = new google.maps.Map(document.getElementById('map-edit-quote'), {
	      zoom: 13,
	      center: new google.maps.LatLng(this.state.item?.latitude,this.state.item?.longitude),
	      draggable: true,
	      zoomControl: true,
	      streetViewControl: false,
	      fullscreenControl: false,
	      scaleControl: false,
	      rotateControl: false
	    });

	    const marker = new google.maps.Marker({
	      position: new google.maps.LatLng(this.state.item?.latitude,this.state.item?.longitude),
	      map,
	      title: 'Ubicación',
	      animation: google.maps.Animation.DROP,
	      draggable: false,
	      icon: PinIcon
	    })

	    marker.addListener('click',() => {
	    	window.open(`https://maps.google.com/?q=${ this.state.item?.latitude },${ this.state.item?.longitude }`);
		});
	}

	changeDate = () => {
		this.props.onClose(true);
	}
	
	render() {
		const { item } = this.state;
		const { city } = this.state.item;
		const address = [city].filter((i: any) => i != null && i != '').join(' - ');

		return (
			<div id="modal-quotes-edit">
				<div className="row row-blue">
					<div className="col-md-6">
						<p><strong>Cliente: </strong> { item?.user?.full_name }</p>
						<p><strong>Teléfono: </strong> { item?.user?.phone }</p>
						<p><strong>RIF / C.I.:</strong> { [Constants.DOCUMENT_TYPES.V,Constants.DOCUMENT_TYPES.E].indexOf(item?.user?.document_type_id) != -1 ? item?.user?.full_document : item?.user?.full_tax_document }</p>
					</div>
					<div className="col-md-6 container-right">
						<p className="text-right number-red">Nº{ item.number }</p>
						<p className={ `text-right ${ item?.type_id == Constants.QUOTE_TYPES.URGENT.toString() ? 'urgent' : '' }` }>{ item?.type_id == Constants.QUOTE_TYPES.URGENT.toString() ? ('Urgente ' + moment(item.date).format('DD-MM-YYYY')) : moment(item.date).format('DD-MM-YYYY') }</p>
						<p className="text-right">{ moment(item.journey?.since,'HH:mm:ss').format('hh:mm a') } - { moment(item.journey?.until,'HH:mm:ss').format('hh:mm a') }</p>
					</div>
				</div>
				<div className="row row-service">
					<div className="col-md-6">
						<p><strong>Servicio: </strong> { item?.service?.name }</p>
						{
							item?.quote_accessories?.length > 0 && (
								<p><strong>Complementos:</strong> { Globals.getAccessories(item?.quote_accessories) }</p>
							)
						}
						<p><strong>Superficie/Cantidad: </strong> { item?.area }</p>
						{
							item.surcharges > 0 && (
								<p><strong>{ this.props.surcharge_title }:</strong> { Globals.formatMiles(item.surcharges) }</p>
							)
						}
						{
							item.journey_surcharge > 0 && (
								<p><strong>Recargo por Jornada:</strong> { Globals.formatMiles(item.journey_surcharge) }</p>
							)
						}
					</div>
					<div className="col-md-6 text-right">
						{
							item.price !== null && (
								<React.Fragment>
									<p className="price-title">Costo</p>
									<p className="price">{ Globals.formatMiles(item.price) }</p>
								</React.Fragment>
							) || ''
						}
					</div>
				</div>
				{
					item.discount && (
						<div className="row row-service">
							<div className="col-md-8">
								<p><strong>Código de descuento: </strong> { item?.discount?.code }</p>
								<p><strong>Descuento: </strong> { item?.discount?.percent }%</p>
							</div>
						</div>
					)
				}
				<div className="container-padding-address">
					{
						(city) && (
							<React.Fragment>
								<div className="container-title">
									<img src={ GoogleMapsIcon } />
									<p>Dirección</p>
								</div>
								<p>{ address }</p>
							</React.Fragment>
						)
					}
					{
						this.state.item?.latitude && this.state.item?.longitude && (
							<div id="map-edit-quote"></div>
						)
					}
					{
						item?.comments && (
							<div className="comments">
								<div className="container-title">
									<p>Descripción</p>
								</div>
								<p>{ item?.comments }</p>
							</div>
						)
					}
				</div>
				<div className="text-center container-submit">
					<button className="btn" type="submit" onClick={ () => this.changeDate() }>
						Cambiar fecha y hora
					</button>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		surcharge_title: state.surcharge_title
	}
})(EditQuote);